export enum AccountTeam {
  PRODUCT_AND_MARKETING = 'PRODUCT_AND_MARKETING',
  ENGINEERING = 'ENGINEERING',
}
